/* RT header vehicle search — route "2020 f150" to the YMM finder.
   Parser is DOM-free so node tests can load this file. */
(function (root) {
  var FINDER = '/pages/year-make-model-search';
  var YEAR_MIN = 2000;
  var YEAR_MAX = 2026;
  var NOISE = {
    rims: 1, rim: 1, wheels: 1, wheel: 1, tires: 1, tire: 1, tyres: 1, tyre: 1,
    for: 1, my: 1, a: 1, the: 1, that: 1, fit: 1, fits: 1, fitting: 1, on: 1,
    with: 1, truck: 1, trucks: 1, suv: 1, car: 1, cars: 1, please: 1, looking: 1,
    need: 1, needs: 1, want: 1, set: 1, sets: 1, of: 1, and: 1, or: 1, in: 1,
    to: 1, by: 1, vehicle: 1, vehicles: 1, shop: 1, find: 1, search: 1
  };
  var DRW = { dually: 1, drw: 1, dual: 1, dualie: 1 };

  function compact(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
  }
  function tokens(s) {
    return String(s || '').toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
  }
  function yearIn(spec, y) {
    y = +y;
    if (!spec) return false;
    var parts = String(spec).split(',');
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      var d = p.indexOf('-');
      if (d > 0) {
        if (y >= +p.slice(0, d) && y <= +p.slice(d + 1)) return true;
      } else if (+p === y) return true;
    }
    return false;
  }
  function isDrwName(n) {
    return /\(DRW\)\s*$/i.test(n || '');
  }
  function looksLikeSize(raw) {
    if (root.RTQ && RTQ.findSize) {
      try { if (RTQ.findSize(raw)) return true; } catch (e) {}
    }
    var s = ' ' + String(raw || '').toLowerCase().replace(/×/g, 'x') + ' ';
    if (/(?:^|[\s])(?:lt|p)?(1[2-9]\d|2\d\d|3[0-4]\d|445)\s*[\/\s.x-]\s*(2[5-9]|[3-8]\d|90)\s*(?:[\/\s.x-]|zr|r)r?\s*(1[3-9]|2[0-6])(?:\s|$)/.test(s)) return true;
    if (/(?:^|[\s])(?:lt|p)?(1[2-9]\d|2\d\d|3[0-4]\d|445)(2[5-9]|[3-8]\d|90)\s*(?:zr|r)\s*(1[3-9]|2[0-6])(?:\s|$)/.test(s)) return true;
    if (/(?:^|[\s])(2[7-9]|3[0-9]|4[0-4])(?:\.\d)?\s*[x\/\s-]\s*(\d{1,2}(?:\.\d{1,2})?)\s*(?:[x\/\s-]|zr|r)r?\s*(1[4-9]|2[0-4])(?:\s|$)/.test(s)) return true;
    if (/(?:^|[\s])\d{1,2}x\d{2,3}(?:\.\d)?(?:\s|$)/.test(s)) return true;
    return false;
  }
  function tokenPrefix(queryToks, modelToks) {
    if (!queryToks.length || queryToks.length >= modelToks.length) return false;
    for (var i = 0; i < queryToks.length; i++) {
      if (queryToks[i] !== modelToks[i]) return false;
    }
    return true;
  }
  function startsWithTokens(toks, aliasToks) {
    if (!aliasToks.length || aliasToks.length > toks.length) return false;
    for (var i = 0; i < aliasToks.length; i++) if (toks[i] !== aliasToks[i]) return false;
    return true;
  }
  function consumeMake(toks, make) {
    var best = null;
    function consider(nTok) {
      if (nTok < 1 || nTok > toks.length) return;
      var hit = { make: make, rest: toks.slice(nTok), used: nTok };
      if (!best || hit.used > best.used) best = hit;
    }
    var aliases = make.a || [];
    var i;
    for (i = 0; i < aliases.length; i++) {
      var at = tokens(aliases[i]);
      if (startsWithTokens(toks, at)) consider(at.length);
      /* compact "dodgeram" against tokens dodge+ram */
      var n;
      for (n = 1; n <= toks.length; n++) {
        if (compact(toks.slice(0, n).join('')) === aliases[i]) consider(n);
      }
    }
    var makeToks = make.t || tokens(make.n);
    if (startsWithTokens(toks, makeToks)) consider(makeToks.length);
    return best;
  }
  function labelOf(hit) {
    var s = hit.year + ' ' + hit.make;
    if (hit.model) s += ' ' + hit.model;
    return s;
  }
  function finderUrl(hit) {
    var sp = [];
    if (hit.year) sp.push('y=' + encodeURIComponent(hit.year));
    if (hit.make) sp.push('make=' + encodeURIComponent(hit.make));
    if (hit.model) sp.push('model=' + encodeURIComponent(hit.model));
    return FINDER + (sp.length ? '?' + sp.join('&') : '');
  }

  function parse(raw, index) {
    if (!raw || !index || !index.makes) return null;
    var q = String(raw).trim();
    if (!q || looksLikeSize(q)) return null;
    var toks = tokens(q);
    if (!toks.length) return null;

    var year = null;
    var kept = [];
    var wantDrw = false;
    for (var i = 0; i < toks.length; i++) {
      var t = toks[i];
      if (/^\d{4}$/.test(t) && +t >= YEAR_MIN && +t <= YEAR_MAX && !year) { year = t; continue; }
      if (DRW[t]) { wantDrw = true; kept.push(t); continue; }
      if (NOISE[t]) continue;
      kept.push(t);
    }
    if (!year || !kept.length) return null;

    var makes = index.makes;
    var scopes = [{ make: null, rest: kept, used: 0 }];
    var mi;
    for (mi = 0; mi < makes.length; mi++) {
      var c = consumeMake(kept, makes[mi]);
      if (c) scopes.push(c);
    }

    var exact = [];
    var family = [];
    var si;
    for (si = 0; si < scopes.length; si++) {
      var scope = scopes[si];
      var scoped = scope.make ? [scope.make] : makes;
      var rest = scope.rest;
      var restCompact = compact(rest.join(''));
      for (mi = 0; mi < scoped.length; mi++) {
        var make = scoped[mi];
        var models = make.m || [];
        for (var j = 0; j < models.length; j++) {
          var mo = models[j];
          if (!yearIn(mo.y, year)) continue;
          var aliases = mo.a || [];
          var isExact = false;
          if (restCompact) {
            for (var k = 0; k < aliases.length; k++) {
              if (aliases[k] === restCompact) { isExact = true; break; }
            }
          }
          if (isExact) {
            exact.push({ year: year, make: make.n, model: mo.n, drw: isDrwName(mo.n), used: (scope.used || 0) + rest.length });
            continue;
          }
          if (rest.length && tokenPrefix(rest, mo.t || [])) {
            family.push({ year: year, make: make.n, model: mo.n, drw: isDrwName(mo.n) });
          }
        }
      }
    }

    function dedup(list) {
      var seen = {};
      var out = [];
      for (var i = 0; i < list.length; i++) {
        var h = list[i];
        var k = h.make + '\t' + (h.model || '');
        if (seen[k]) continue;
        seen[k] = 1;
        out.push(h);
      }
      return out;
    }
    function pick(list) {
      list = dedup(list);
      if (!list.length) return null;
      var drw = list.filter(function (h) { return h.drw; });
      var srw = list.filter(function (h) { return !h.drw; });
      var use = wantDrw ? (drw.length ? drw : list) : (srw.length ? srw : list);
      if (use.length === 1) {
        return { kind: 'vehicle', year: use[0].year, make: use[0].make, model: use[0].model,
                 label: labelOf(use[0]), url: finderUrl(use[0]), hits: use };
      }
      /* several equally exact models — don't guess 1500 vs 2500 */
      var makesSet = {};
      use.forEach(function (h) { makesSet[h.make] = 1; });
      var makeNames = Object.keys(makesSet);
      if (makeNames.length === 1 && use.length > 1) {
        var fam = { year: year, make: makeNames[0], model: '', label: year + ' ' + makeNames[0], url: finderUrl({ year: year, make: makeNames[0] }), hits: use, family: true };
        return { kind: 'vehicle', year: fam.year, make: fam.make, model: '', label: fam.label, url: fam.url, hits: use, family: true };
      }
      return { kind: 'vehicle', year: year, make: use[0].make, model: '', label: year + ' vehicle', url: FINDER + '?y=' + encodeURIComponent(year), hits: use, family: true };
    }

    if (exact.length) return pick(exact);

    if (family.length) {
      family = dedup(family);
      if (family.length === 1) return pick(family);
      var famMakes = {};
      family.forEach(function (h) { famMakes[h.make] = 1; });
      var fm = Object.keys(famMakes);
      if (fm.length === 1) {
        return { kind: 'vehicle', year: year, make: fm[0], model: '', label: year + ' ' + fm[0], url: finderUrl({ year: year, make: fm[0] }), hits: family, family: true };
      }
    }

    var makeOnly = [];
    for (si = 0; si < scopes.length; si++) {
      if (scopes[si].make && !scopes[si].rest.length) {
        makeOnly.push({ year: year, make: scopes[si].make.n, model: '' });
      }
    }
    makeOnly = dedup(makeOnly);
    if (makeOnly.length === 1) {
      return { kind: 'vehicle', year: makeOnly[0].year, make: makeOnly[0].make, model: '',
               label: labelOf(makeOnly[0]), url: finderUrl(makeOnly[0]), hits: makeOnly, family: true };
    }

    return null;
  }

  var api = { parse: parse, finderUrl: finderUrl, labelOf: labelOf, yearIn: yearIn, compact: compact, looksLikeSize: looksLikeSize, FINDER: FINDER };
  root.RTV = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : (typeof global !== 'undefined' ? global : this));

/* DOM: header intercept, dropdown CTA, finder prefill, /search banner */
(function () {
  if (typeof document === 'undefined') return;
  var index = null;
  var indexUrl = (window.RTV_CFG && RTV_CFG.index) || '';
  var loaded = false;

  function cfgFinder() {
    return (window.RTV_CFG && RTV_CFG.finder) || (window.RTV && RTV.FINDER) || '/pages/year-make-model-search';
  }

  function loadIndex(cb) {
    if (index) { cb(index); return; }
    if (!indexUrl) { cb(null); return; }
    fetch(indexUrl).then(function (r) { return r.json(); }).then(function (j) {
      index = j;
      loaded = true;
      cb(index);
    }).catch(function () { cb(null); });
  }

  function matchOf(raw) {
    if (!window.RTV || !index) return null;
    return RTV.parse(raw, index);
  }

  function selectedProduct(form) {
    var sel = form && form.querySelector('[aria-selected="true"] a');
    if (!sel) return false;
    return !sel.classList.contains('rtv-cta');
  }

  /* The /search sort form carries the query as a hidden q — not a search box. */
  function typedInput(form) {
    var inp = form.querySelector('input[name="q"]');
    return inp && inp.type !== 'hidden' ? inp : null;
  }

  function ensureBar(form) {
    var bar = form.querySelector('.rtv-bar');
    if (bar) return bar;
    if (!typedInput(form)) return null;
    var results = form.querySelector('[data-predictive-search]');
    /* /search page box: its panel sits inside .field (a flex row) — no bar there */
    if (results && results.parentNode !== form) return null;
    bar = document.createElement('div');
    bar.className = 'rtv-bar';
    bar.hidden = true;
    var inp = form.querySelector('input[name="q"]');
    var oid = 'rtv-option-' + ((inp && inp.id) || Math.random().toString(36).slice(2, 7));
    bar.innerHTML = '<ul class="rtv-bar__list list-unstyled" role="none"><li class="predictive-search__list-item" role="option" aria-selected="false" id="' + oid + '">' +
      '<a class="rtv-cta predictive-search__item" href="#" tabindex="-1">' +
      '<span class="rtv-cta__kicker">Rims that fit</span>' +
      '<span class="rtv-cta__label"></span>' +
      '<span class="rtv-cta__hint">Year / make / model finder</span>' +
      '</a></li></ul>';
    if (results) form.insertBefore(bar, results);
    else form.appendChild(bar);
    return bar;
  }

  function paintBar(form, hit) {
    var bar = ensureBar(form);
    if (!bar) return;
    var a = bar.querySelector('.rtv-cta');
    var lab = bar.querySelector('.rtv-cta__label');
    if (!hit) { bar.hidden = true; return; }
    a.href = hit.url;
    lab.textContent = hit.label;
    bar.hidden = false;
  }

  function onInput(form) {
    var input = typedInput(form);
    if (!input) return;
    var raw = input.value.trim();
    loadIndex(function () {
      paintBar(form, matchOf(raw));
    });
  }

  function bindForm(form) {
    if (!form || form.getAttribute('data-rtv') === '1') return;
    form.setAttribute('data-rtv', '1');
    ensureBar(form);
    var input = typedInput(form);
    if (input) {
      input.addEventListener('input', function () { onInput(form); });
      input.addEventListener('focus', function () { onInput(form); });
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    var input = typedInput(form);
    if (!input) return;
    var action = (form.getAttribute('action') || '');
    if (!/(^|\/)search$/.test(action.split('?')[0].replace(/\/$/, '')) && action.indexOf('/search') !== 0) return;
    if (selectedProduct(form)) return;
    var raw = (input.value || '').trim();
    if (!raw || !index) return;
    var hit = matchOf(raw);
    if (!hit) return;
    e.preventDefault();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    else e.stopPropagation();
    window.location.assign(hit.url);
  }, true);

  function bannerSearchPage() {
    if (location.pathname.replace(/\/$/, '') !== '/search') return;
    var sp = new URLSearchParams(location.search);
    var q = sp.get('rtq') || sp.get('q') || '';
    if (!q) return;
    loadIndex(function () {
      var hit = matchOf(q);
      if (!hit) return;
      if (document.querySelector('.rtv-search-banner')) return;
      if (document.getElementById('rt-veh-banner')) return; /* sections/rt-search.liquid paints its own */
      var main = document.getElementById('MainContent') || document.querySelector('main');
      if (!main) return;
      var b = document.createElement('div');
      b.className = 'rtv-search-banner';
      b.innerHTML = '<a class="rtv-cta rtv-cta--page" href="' + hit.url + '">' +
        '<span class="rtv-cta__kicker">Looking for rims that fit?</span>' +
        '<span class="rtv-cta__label">' + hit.label.replace(/</g, '') + '</span>' +
        '<span class="rtv-cta__hint">Use the vehicle finder — keyword search does not check fitment.</span></a>';
      main.insertBefore(b, main.firstChild);
    });
  }

  function prefillFinder() {
    if (location.pathname.indexOf('year-make-model-search') === -1) return;
    var sp = new URLSearchParams(location.search);
    var y = sp.get('y') || '';
    var make = sp.get('make') || '';
    var model = sp.get('model') || '';
    if (!y && !make && !model) return;

    function setSelect(id, value) {
      var el = document.getElementById(id);
      if (!el || !value) return false;
      var ok = false;
      for (var i = 0; i < el.options.length; i++) {
        if (el.options[i].value === value) { ok = true; break; }
      }
      if (!ok) return false;
      if (el.value === value) return true;
      el.value = value;
      el.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    function wait(fn, ms) {
      var t0 = Date.now();
      (function tick() {
        if (fn()) return;
        if (Date.now() - t0 > (ms || 8000)) return;
        setTimeout(tick, 80);
      })();
    }
    wait(function () {
      var makeSel = document.getElementById('rtfind-make');
      if (!makeSel || makeSel.options.length < 2) return false;
      if (make && !setSelect('rtfind-make', make)) return false;
      if (!y && !model) return true;
      wait(function () {
        var yearSel = document.getElementById('rtfind-year');
        if (!yearSel || yearSel.disabled || yearSel.options.length < 2) return false;
        if (y && !setSelect('rtfind-year', y)) return false;
        if (!model) return true;
        wait(function () {
          var modelSel = document.getElementById('rtfind-model');
          if (!modelSel || modelSel.disabled || modelSel.options.length < 2) return false;
          setSelect('rtfind-model', model);
          return true;
        });
        return true;
      });
      return true;
    });
  }

  function boot() {
    document.querySelectorAll('form[action*="search"]').forEach(bindForm);
    loadIndex(function () {
      document.querySelectorAll('form[action*="search"]').forEach(function (form) { onInput(form); });
      bannerSearchPage();
    });
    prefillFinder();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
